import TextHeading from "components/TextHeading";
import TagStatus from "components/TagStatus";
import Divider from "components/Divider";
import { Button, Icon } from "@utp/react-components-prod";
import useDelivery from "./hooks/useDelivery";
import LoadingPage from "components/LoadingPage";
import { URL_RESULTS_ADMISSION } from "utils/ConstantsAndNum";
import { Contact } from "./hooks/components/Contact";
import { SpanText } from "./hooks/components/SpanText";
import useRoleActive from "hooks/useRoleActive";

const Delivery = () => {
  const { titleSummary, isOutOfData, statusSummary, isLoading } = useDelivery();
  const { isRoleEPG } = useRoleActive();

  const handleRedictExternalLink = () => {
    window.location.href = URL_RESULTS_ADMISSION;
  };

  const handleTextSummary = () => {
    if (isRoleEPG) {
      return (
        <span>
          Tu examen ha finalizado. <br />
          Una vez culminadas todas las evaluaciones, enviaremos tus resultados
          al correo electrónico registrado.
        </span>
      );
    }
    return "Revisa tus resultados a partir de mañana a las 8:00 a.m.";
  };

  if (isLoading) {
    return <LoadingPage isLoading={isLoading} />;
  }
  return (
    <div className="bg-02 p-8" data-testid="delivery-page">
      <div className="bg-01 p-8 rounded-md max-w-base m-auto">
        <div className="flex gap-4 items-center mb-8">
          <TextHeading text={titleSummary} />
          <TagStatus type={statusSummary} />
        </div>
        <Divider />

        <div className="bg-grey-05 border-solid border border-mid-grey-40 rounded-default p-10 mt-8">
          <p className="text-body-02 text-color-02 leading-snug">
            {isOutOfData ? (
              <SpanText>
                {" "}
                La fecha de tu examen ha finalizado. <br />
                Por favor, comunícate con tu asesor educativo para
                reprogramarlo.
              </SpanText>
            ) : (
              <SpanText>{handleTextSummary()}</SpanText>
            )}
          </p>
        
        {
          !isRoleEPG && 
          <Button
            color="primary"
            data-testid="button-redict-external-link"
            text="Ver resultados"
            iconName="external-link"
            className={`mt-8 ${isOutOfData ? "hidden" : ""}`}
            onClick={handleRedictExternalLink}
          />
        }
        </div>

        <Divider className="mt-9" />

        <div className="">
          <div className="mt-8 text-color-02 rounded-default px-8 flex items-start">
            <Icon
              iconName="help-circle"
              size={24}
              className="mr-2 text-neutral-02"
            />
            <div className="ml-5">
              <p className="text-body font-bold mb-2">¿Necesitas ayuda?</p>
              <Contact />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Delivery;
